import { Account } from 'model/IChat';
import React, { forwardRef } from 'react';
import TimeListInput from 'reusable-components/book-block/BookBlockTimeSelector/TimeListInput';
import WatchIcon from 'reusable-components/icons/outline/WatchIcon';
import PopoverInput from 'reusable-components/inputs/PopoverInput';
import { formatTimeForDisplay } from 'utils/timeHelpers/formatTimeForDisplay';

interface BookBlockTimeSelectorProps {
  selectedDate?: string;
  selectedTime: string;
  availableTimes: { time: string; locals: string[] }[];
  onTimeChange: (time: string) => void;
  preferredLocal?: Partial<Account>;
  isLocalPicker?: boolean;
  hasAvailableSelectedTime: boolean;
  isLoading?: boolean;
}

const BookBlockTimeSelector = forwardRef(
  (
    {
      selectedDate,
      selectedTime,
      onTimeChange,
      availableTimes = [],
      preferredLocal,
      isLocalPicker,
      hasAvailableSelectedTime,
      isLoading,
    }: BookBlockTimeSelectorProps,
    ref,
  ) => {
    const hasAvailableTimes =
      isLocalPicker && availableTimes
        ? availableTimes?.some(({ locals }) =>
            locals.includes(preferredLocal?.id),
          )
        : true;

    return (
      <PopoverInput
        ref={ref}
        icon={WatchIcon}
        value={selectedTime ? formatTimeForDisplay(selectedTime) : undefined}
        placeholder="Start time"
        disabled={!selectedDate || !hasAvailableTimes}
        hasError={!hasAvailableSelectedTime && isLocalPicker}
        testId="BookBlockTimeSelector"
        children={
          <TimeListInput
            selectedTime={selectedTime}
            availableTimes={availableTimes}
            onTimeChange={onTimeChange}
            preferredLocal={preferredLocal}
            isLocalPicker={isLocalPicker}
          />
        }
        isLoading={isLoading}
      />
    );
  },
);

export default BookBlockTimeSelector;
